import { render, staticRenderFns } from "./NewMemberCard.vue?vue&type=template&id=035aab9e&scoped=true"
import script from "./NewMemberCard.vue?vue&type=script&lang=js"
export * from "./NewMemberCard.vue?vue&type=script&lang=js"
import style0 from "./NewMemberCard.vue?vue&type=style&index=0&id=035aab9e&prod&scoped=true&lang=less"
import style1 from "./NewMemberCard.vue?vue&type=style&index=1&id=035aab9e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035aab9e",
  null
  
)

export default component.exports